import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'insight',
	prefix: 'insight',
	key: 'insight_id',
	fields: {
		insight_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		insight_type: Model.SCHEMA_NUMBER,
		insight_date: Model.SCHEMA_NUMBER,
		insight_stamp: Model.SCHEMA_TEXT,
		insight_period: Model.SCHEMA_NUMBER,
		insight_value: Model.SCHEMA_NUMBER
	}
})
